import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      className="min-h-screen bg-[#FAF6F0] text-[#2A2521] flex items-center justify-center px-6"
      data-testid="payment-cancel-page"
    >
      <div className="max-w-lg w-full text-center">
        <XCircle className="w-12 h-12 text-[#6B6560] mx-auto mb-6" />
        <p className="label-eyebrow text-[#A67C2E] mb-3">Payment Cancelled</p>
        <h1 className="font-heading text-3xl md:text-4xl mb-4">
          No worries — nothing was charged.
        </h1>
        <p className="text-[#6B6560] text-sm mb-10">
          Your application is saved. You can return to complete payment at any time.
        </p>
        <Link
          to="/apply"
          className="btn-gold inline-flex items-center gap-2 px-8 py-3.5 rounded-sm text-sm"
          data-testid="return-to-apply-btn"
        >
          <ArrowLeft className="w-4 h-4" /> Return to Application
        </Link>
      </div>
    </div>
  );
}
